import { createSelector } from 'reselect'

const root = (state) => state.get('composer')
export const savedReplies = (state) => root(state).get('savedReplies')
  .sortBy(reply => reply.get('updatedAt'))
  .reverse()
export const selectedSavedReplyId = (state) => root(state).get('selectedSavedReplyId')

export const savedReplyToPopulate = (id) => createSelector(savedReplies,
  (savedReplies) => savedReplies.find(reply => reply.get('id') === id))

export const composerTextToInsert = (state) => root(state).get('composerTextToInsert')



// WEBPACK FOOTER //
// ./src/scripts/app/modules/composer/selectors.js